<div class="widget-header">

  <h2 class="widget-header-title">{{widget.title}}</h2>


  <ng-container *ngTemplateOutlet="widgetButtonsTemplate"></ng-container>

</div>
<div class="widget-content">
  <ng-container *ngIf="widget.widgetType == widgetTypes.image">
    <image-widget [widget]="widget"></image-widget>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.text">
    <text-widget [widget]="widget"></text-widget>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.barChart">
    <bar-chart-widget [widget]="widget"></bar-chart-widget>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.lineChart">
    <line-chart-widget [widget]="widget" (isLoading)="isLoading = $event" (hasErrored)="hasErrored = $event"></line-chart-widget>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.pieChart">
    <pie-chart-widget [widget]="widget"></pie-chart-widget>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.fuelGauge">
    <fuel-gauge-chart-widget [widget]="widget"></fuel-gauge-chart-widget>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.textControl">
    <text-input-control-widget [widget]="widget"></text-input-control-widget>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.numberControl">
    <number-input-control-widget [widget]="widget"></number-input-control-widget>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.dateTimeControl">
    <datetime-input-control-widget [widget]="widget"></datetime-input-control-widget>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.autoCompleteControl">
    <autocomplete-input-control-widget [widget]="widget"></autocomplete-input-control-widget>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.eveUserAutoCompleteControl">
    <eve-user-autocomplete-input-control-widget [widget]="widget"></eve-user-autocomplete-input-control-widget>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.functionNumberAutoCompleteControl">
    <function-number-autocomplete-input-control-widget [widget]="widget"></function-number-autocomplete-input-control-widget>
  </ng-container>
</div>

<div class="widget-footer">
  <!--hasErrored isLoading-->
  <div style="text-align: left; padding-left: 5px;">
    <mat-icon class="mat-icon-widget-type-button goodStatus" [matTooltip]="hasErrored ? 'Status: Errored' : isLoading ? 'Status: Loading' : 'Status: Good' " matTooltipPosition="right" [ngClass]="{'loadingStatus': isLoading, 'erroredStatus': hasErrored}" style="font-size: 25px;">info</mat-icon>
  </div>
</div>
